export const LocalConfigs = {
    API_URL: 'https://api.prospector.soloweb.pt',
    START_YEAR: 2016
};
